import apiFetch from '../apiFetch'

export default function (token, classId) {
  const queryParamsArray = [
    `classId=${classId}`
  ]
  const queryParams = queryParamsArray.reduce(
    (result, query, idx) => result + (query ? (result ? `&${query}` : `?${query}`) : '')
    , ''
  )
  return apiFetch({ endPoint: `CampaignGroup${queryParams}`, method: 'GET', body: null, token: token })
}
